import { render, staticRenderFns } from "./OrderRow.vue?vue&type=template&id=0345576c&scoped=true&"
import script from "./OrderRow.vue?vue&type=script&lang=js&"
export * from "./OrderRow.vue?vue&type=script&lang=js&"
import style0 from "./OrderRow.vue?vue&type=style&index=0&id=0345576c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0345576c",
  null
  
)

export default component.exports